export default "__VITE_ASSET__cM0Tl35W__"